import React from "react";

export default function SQL_Constraints() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Constraints</h1>
      <p>This is the SQL_Constraints component generated from the SQL JSON.</p>
    </div>
  );
}
